(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wch-retail-delivery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wch-delivery-estimate')) {
  customElements.define('wch-delivery-estimate', class extends HTMLElement {
    connectedCallback() {
      this.updateDates();
      this.refreshTimer = setInterval(() => this.updateDates(), 60000);
    }
    disconnectedCallback() {
      clearInterval(this.refreshTimer);
    }
    updateDates() {
      const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit'
      }).formatToParts(new Date());
      const value = type => Number(parts.find(part => part.type === type).value);
      const day = new Date(Date.UTC(value('year'), value('month') - 1, value('day'), 12));
      const dates = [];
      while (dates.length < 4) {
        day.setUTCDate(day.getUTCDate() + 1);
        if (day.getUTCDay() !== 0 && day.getUTCDay() !== 6) dates.push(new Date(day));
      }
      const times = this.querySelectorAll('[data-delivery-dates] time');
      const format = new Intl.DateTimeFormat('en-US', {
        timeZone: 'UTC', weekday: 'short', month: 'short', day: 'numeric'
      });
      [dates[1], dates[3]].forEach((date, index) => {
        if (!times[index]) return;
        const label = format.format(date);
        if (times[index].textContent !== label) times[index].textContent = label;
        times[index].dateTime = date.toISOString().slice(0, 10);
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
